import React, { useState } from 'react';
import {
  ForgotPasswordForOLB,
  SendFactorForForgotPassword,
  VerifyPasscodeForForgotPassword,
  ResetPasswordForOLB,
} from 'api';
import { ForgotPasswordFormForOLB, FactorSelectionForm, VerifyPasscodeForm, ResetPasswordForm } from 'forms';
import { useApi } from 'hooks';
import { Process, Success } from 'common';

const ForgotPasswordPage = () => {
  // states. todo: reducer later on
  const [step, setStep] = useState(1);
  const [login, setlogin] = useState();
  const [factors, setFactors] = useState();
  const [selectedFactor, setSelectedFactor] = useState();
  const [stateToken, setStateToken] = useState();

  // API
  const [forgotStatus, callForgotPassword] = useApi(ForgotPasswordForOLB);
  const [sendStatus, callSendFactor] = useApi(SendFactorForForgotPassword);
  const [verifyStatus, callVerifyPasscode] = useApi(VerifyPasscodeForForgotPassword);
  const [resetStatus, callResetPassword] = useApi(ResetPasswordForOLB);

  const forgot = (login, accountNumber, last4ssn) => {
    callForgotPassword(login, accountNumber, last4ssn).then((data) => {
      if (data) {
        setlogin(login);
        setFactors(data);
        setStep(2);
      }
    });
  };

  const send = (factor) => {
    setSelectedFactor(factor);
    callSendFactor(login, factor).then((data) => {
      if (data) {
        setStateToken(data.stateToken);
        setStep(3);
      }
    });
  };

  const verify = (passcode) => {
    callVerifyPasscode(stateToken, selectedFactor, passcode).then((data) => {
      if (data) setStep(4);
    });
  };

  const reset = (password) => {
    callResetPassword(stateToken, password).then((data) => {
      if (data) setStep(5);
    });
  };

  // todo: refactor
  const isLoading = () =>
    forgotStatus.isLoading || sendStatus.isLoading || verifyStatus.isLoading || resetStatus.isLoading;
  const error = () => {
    let tempError = false;
    if (forgotStatus.error) tempError = forgotStatus.error;
    if (sendStatus.error) tempError = sendStatus.error;
    if (verifyStatus.error) tempError = verifyStatus.error;
    if (resetStatus.error) tempError = resetStatus.error;
    return tempError;
  };

  return (
    <Process error={error} isLoading={isLoading}>
      {step === 1 && <ForgotPasswordFormForOLB forgot={forgot} />}
      {step === 2 && <FactorSelectionForm factors={factors} send={send} />}
      {step === 3 && (
        <VerifyPasscodeForm verify={verify} selectedFactor={selectedFactor} resend={() => send(selectedFactor)} />
      )}
      {step === 4 && <ResetPasswordForm login={login} reset={reset} />}
      {step === 5 && (
        <Success
          header={'You have successfully reset your password. Please log in to access your application'}
          href={'/sign-in'}
        />
      )}
    </Process>
  );
};

export default ForgotPasswordPage;
